/** الخلفية المُعلَّمة لشاشات بوابة مدير النظام (دخول / تغيير كلمة المرور). */
export function PortalFrame({ title, sub, children, width = 420 }) {
  return (
    <div
      className="min-h-screen grid place-items-center p-5 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #FF7A1A 0%, #FFB627 60%, #EC4899 110%)' }}
    >
      <div
        className="absolute -top-16 -left-16 w-[260px] h-[260px] rounded-full pointer-events-none"
        style={{ background: 'rgba(255,255,255,.10)' }}
      />
      <div
        className="absolute bottom-[10%] right-[8%] w-[180px] h-[180px] rounded-full pointer-events-none"
        style={{ background: 'rgba(255,255,255,.08)' }}
      />

      <div className="card w-full p-6 relative z-10 shadow-active" style={{ maxWidth: width }}>
        <img
          src="/kidzo-logo.png"
          alt="Kids Zone"
          className="h-14 mx-auto object-contain"
        />
        <h1 className="text-[22px] font-extrabold text-center mt-4 mb-0 tracking-tight">{title}</h1>
        {sub ? <p className="text-ink-3 text-[12.5px] text-center mt-1.5 mb-0">{sub}</p> : null}
        <div className="mt-5">{children}</div>
      </div>

      <div className="absolute bottom-4 text-[11px] z-10" style={{ color: 'rgba(255,255,255,.85)' }}>
        منصّة Kids Zone • بوابة إدارة الشركات
      </div>
    </div>
  );
}
